/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState } from 'react'
import { getSoundsEnabled, setSoundsEnabled } from '../lib/sounds'

const SettingsContext = createContext(null)

export function SettingsProvider({ children }) {
    const [soundsOn, setSoundsOn] = useState(() => getSoundsEnabled())

    const toggleSounds = () => {
        const next = !soundsOn
        setSoundsOn(next)
        setSoundsEnabled(next)
    }

    return (
        <SettingsContext.Provider value={{ soundsOn, toggleSounds }}>
            {children}
        </SettingsContext.Provider>
    )
}

export function useSettings() {
    const ctx = useContext(SettingsContext)
    return ctx || { soundsOn: true, toggleSounds: () => {} }
}
